import PropTypes from "prop-types";
import content from "app-content";
import styles from "./index.css";

const ItemCount = ({ itemCount }) => {
  const labelText =
    itemCount === 1
      ? content.saved_items_application_title_subtext_single
      : content.saved_items_application_title_subtext_multi;

  return <div className={styles.itemCount}>{`${itemCount} ${labelText}`}</div>;
};

ItemCount.propTypes = {
  itemCount: PropTypes.number.isRequired
};

export default ItemCount;
